import { render, staticRenderFns } from "./page-question-notinterested.vue?vue&type=template&id=1842aeb2"
import script from "./page-question-notinterested.js?vue&type=script&lang=js&external"
export * from "./page-question-notinterested.js?vue&type=script&lang=js&external"
import style0 from "./page-question-notinterested.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports